import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import useModal from '@/@core/components/base-modal/hooks/useModal'
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import { privilegeTagModel } from '@/models/privilege/privilege-form'
import tagModel from '@/models/tag/tag-list'

export default function usePrivilegeTag(props) {
  const vm = getCurrentInstance().proxy

  const { fetchTagDetail, addTag, removeTag } = privilegeTagModel()
  const { fetchTagList } = tagModel()

  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal()

  const formData = reactive({
    tier: null,
    tag: null,
  })

  const optionData = reactive({
    tagList: [],
  })

  const fetchTagListData = () => {
    window.$loading(true)
    store
      .dispatch('api/apiRequest', fetchTagList)
      .then(resp => {
        if (resp.data.tag_list.length > 0) {
          optionData.tagList = resp.data.tag_list.map(obj => ({
            seq: obj.seq,
            label: obj.tag,
          }))
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const fetchTagDetailData = () => {
    window.$loading(true)
    fetchTagDetail.payload.Privilege_Id = props.privilegeId

    store
      .dispatch('api/apiRequest', fetchTagDetail)
      .then(resp => {
        formData.tag = resp.data.tag_list.length > 0 ? resp.data.tag_list : null
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const onAddTag = tagObj => {
    window.$loading(true)
    addTag.payload.Privilege_Id = props.privilegeId
    addTag.payload.Tag = tagObj.label

    store
      .dispatch('api/apiRequest', addTag)
      .then(resp => {
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const onRemoveTag = tagObj => {
    window.$loading(true)
    removeTag.payload.Privilege_Id = props.privilegeId
    removeTag.payload.Tag = tagObj.label

    store
      .dispatch('api/apiRequest', removeTag)
      .then(resp => {
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const handlers = (map, vm) => ({
    ...map,
    // space
    32: e => {
      e.preventDefault()
      if (vm.search.length > 0) {
        vm.search = `${vm.search}-`
      }
    },
  })

  const onSubmitForm = () => {
    vm.$emit('onNextStep')
  }

  const checkFormCreateOrEdit = () => {
    if (router.currentRoute.query.privilegeId) {
      vm.$emit(
        'onGetPrivilegeId',
        parseInt(router.currentRoute.query.privilegeId),
      )
    }
  }

  onBeforeMount(() => {
    checkFormCreateOrEdit()
    fetchTagListData()
    if (props.privilegeId || props.isEdit) {
      fetchTagDetailData()
    }
  })

  return {
    formData,
    optionData,
    onSubmitForm,
    onRemoveTag,
    onAddTag,
    handlers,
  }
}
